import CTASection from "../components/ui/CTASection";
import ServicesSection from "../components/sections/ServicesSection";
import AboutSection from "../components/sections/AboutSection";
import PartnersSection from "../components/sections/PartnersSection";
import HeroSection from "../components/sections/HeroSection";
import TestimonialsSection from "../components/sections/TestemonialsSection";
import AutoInsurancePromo from "../components/sections/AutoInsurancePromo";

const Home = () => {
  return (
    <>
      {/* Home Section */}
      <HeroSection />

      {/* Serviços Section */}
      <ServicesSection />

      {/* Sobre Nós Section */}
      <AboutSection />

      {/* Parceiros Section */}
      <PartnersSection />

      {/* Promo Section */}
      <AutoInsurancePromo />

      {/* Depoimentos Section */}
      <TestimonialsSection />

      {/* CTA Section */}
      <CTASection
        title="Pronto para proteger o que importa?"
        description="Solicite uma cotação gratuita e descubra como podemos ajudar você a encontrar a proteção ideal para suas necessidades."
        buttonText="Simular Agora"
        buttonLink="/simulacao"
      />
    </>
  );
};

export default Home;
